import { Tooltip } from 'antd';

import { UndoOutlined } from '@ant-design/icons';

export const ResetFormStatus = ({ form, productData }) => {
  return (
    <Tooltip title='Reset'>
      <UndoOutlined
        style={{ fontSize: 14, color: '#595959' }}
        onClick={() => {
          const { status } = productData;
          const currentFormValues = form.getFieldsValue();
          form.setFieldsValue({
            ...currentFormValues,
            status,
          });
        }}
      />
    </Tooltip>
  );
};
